import { IAuthor } from 'generated/types/contentful'
import { Asset, parseAsset } from './asset'
import { ContentfulEntity, parseSystemFields } from 'services/ContentfulService/utils'

export interface Author extends ContentfulEntity {
	/** firstName */
	firstName: string

	/** lastName */
	lastName?: string

	/** title */
	title?: string | undefined

	/** image */
	image: Asset

	/** twitterLink */
	twitterLink?: string | undefined

	/** facebookLink */
	facebookLink?: string | undefined

	/** linkedinLink */
	linkedinLink?: string | undefined

	/** Biography */
	biography?: string | undefined
}

export const DefaultAuthorImage: Asset = {
	contentType: 'image',
	description: 'Floating Head',
	id: 'floating-head',
	title: '',
	url: ''
}

export const parseAuthor = (author: IAuthor): Author => {
	const fields = author.fields
	return {
		firstName: fields.firstName!,
		image: fields?.image ? parseAsset(fields.image) : DefaultAuthorImage,
		lastName: fields.lastName,
		biography: fields.biography,
		facebookLink: fields.facebookLink,
		linkedinLink: fields.linkedinLink,
		title: fields.title,
		id: author.sys.id,
		twitterLink: fields.twitterLink,
		sys: parseSystemFields(author.sys)
	}
}
